const DAY_MS = 24 * 60 * 60 * 1000;

/** Полночь местного календарного дня, к которому относится момент. */
const startOfLocalDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

/**
 * «Сегодня», «вчера», «3 дня назад» на языке интерфейса. Считаем календарные дни, а не
 * окна по 24 часа: практика в 23:30 при взгляде в 00:30 — это уже «вчера», и так же её
 * назовёт сам Intl. Разница между полуночами округляется, чтобы день с переводом часов
 * (23 или 25 часов) не давал ошибку на единицу. Будущие даты, мусор и отсутствующая
 * дата дают null — вызывающий тогда ничего не показывает. null проверяется отдельно:
 * `new Date(null)` — это не «неверная дата», а 1970 год, то есть «20 000 дней назад».
 */
export const formatDaysAgo = (iso, language, now = new Date()) => {
    if (iso == null) {
        return null;
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    const days = Math.round((startOfLocalDay(now) - startOfLocalDay(date)) / DAY_MS);
    if (days < 0) {
        return null;
    }
    try {
        return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(-days, 'day');
    } catch (error) {
        // Незнакомый код языка: формат по умолчанию лучше, чем пустая строка
        return new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }).format(-days, 'day');
    }
};

/**
 * «Сегодня», «завтра», «через 3 дня», «2 дня назад» — в обе стороны.
 *
 * Отдельно от formatDaysAgo, а не вместо него: та функция намеренно молчит о будущем,
 * потому что «практиковались через 2 дня» — бессмыслица, и её вызывающие на это
 * рассчитывают. Срок же смотрит вперёд, и ему нужны обе стороны.
 */
export const formatRelativeDay = (iso, language, now = new Date()) => {
    if (iso == null) {
        return null;
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
        return null;
    }
    const days = Math.round((startOfLocalDay(date) - startOfLocalDay(now)) / DAY_MS);
    try {
        return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(days, 'day');
    } catch (error) {
        return new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }).format(days, 'day');
    }
};
